export default __webpack_public_path__ + "static/media/curly-wave7.77792235.svg";